export const MIGRATIONS_DIRECTORY = 'migrations'
export const MIGRATION_SCRIPT_EXTENSIONS = ['mjs', 'js', 'ts', 'cjs']
